import { useMobile as e } from "../../../hooks/useMobile.mjs";
import { CalendarMonth as t } from "./CalendarMonth.mjs";
import { Divider as n, InlineDual as r } from "../styled/Popups.styled.mjs";
import { useCalendarNavigation as i } from "../hooks/useCalendarNavigation.mjs";
import { useBlockedBounds as a } from "../hooks/useBlockedBounds.mjs";
import { useRangeSelection as o } from "../hooks/useRangeSelection.mjs";
import { useDisabledDateReason as s } from "../hooks/useDisabledDateReason.mjs";
import { useState as c } from "react";
import { useTranslation as l } from "@maat/store-i18n";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
//#region src/components/DatePicker/components/DateRangeCalendar.tsx
var f = ({ value: f, onChange: p, minDate: m, maxDate: h, className: g, annotations: _, blockedRanges: v, onLoadMore: y, loading: b, months: x = 2, lockStart: S = !1, defaultMonth: C, fluid: w = !1, minNights: T, maxNights: E, disabledStartDates: D, disabledEndDates: O, disabledStartReason: k, disabledEndReason: A, blockedReason: j }) => {
	let { t: M } = l("ds"), { isMobile: N } = e(), { view: P, navigate: F, nextMonth: I, nextYear: L } = i({
		defaultMonth: C,
		onLoadMore: y
	}), [R, z] = c(null), B = f?.start ?? null, V = f?.end ?? null, [H, U] = c(S && B ? "end" : "start"), { effectiveMin: W, effectiveMax: G, impossibleRange: K, nextBlockedFrom: q } = a(H, B, v, m, h, T, E), { handleDayClick: J } = o({
		start: B,
		end: V,
		lockStart: S,
		onSelect: (e) => p?.(e),
		impossibleRange: K,
		nextBlockedFrom: q,
		picking: H,
		setPicking: U
	}), Y = H === "start" ? D : O, X = s({
		picking: H,
		start: B,
		minNights: T,
		maxNights: E,
		blockedRanges: v,
		disabledStartDates: D,
		disabledEndDates: O,
		effectiveMax: G,
		reasons: {
			disabledStart: k,
			disabledEnd: A,
			blocked: j
		}
	}), Z = {
		rangeStart: B,
		rangeEnd: V,
		hoverDate: H === "end" ? R : null,
		onDayClick: J,
		onDayHover: z,
		minDate: K ? m : W,
		maxDate: K ? h : G,
		annotations: _,
		blockedRanges: v,
		disabledDates: K ? D : Y,
		reasonForDate: K ? void 0 : X,
		loading: b
	};
	return N || x === 1 ? /* @__PURE__ */ u("div", {
		className: g,
		role: "dialog",
		"aria-label": M("ds:datePicker.rangeDialogLabel"),
		children: /* @__PURE__ */ u(t, {
			year: P.year,
			month: P.month,
			onPrev: () => F(-1),
			onNext: () => F(1),
			...Z,
			fluid: !0
		})
	}) : /* @__PURE__ */ d(r, {
		className: g,
		role: "dialog",
		"aria-label": M("ds:datePicker.rangeDialogLabel"),
		$fluid: w,
		children: [
			/* @__PURE__ */ u(t, {
				year: P.year,
				month: P.month,
				onPrev: () => F(-1),
				onNext: () => F(1),
				...Z,
				hideNext: !0,
				fluid: w
			}),
			!w && /* @__PURE__ */ u(n, {}),
			/* @__PURE__ */ u(t, {
				year: L,
				month: I,
				onPrev: () => F(-1),
				onNext: () => F(1),
				...Z,
				hidePrev: !0,
				fluid: w
			})
		]
	});
};
//#endregion
export { f as DateRangeCalendar };
